module.exports = __webpack_public_path__ + "static/media/swimmy-app-logo.810aee9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swimmy-app-logo.png
// module id = 2110
// module chunks = 0